module.exports = __webpack_public_path__ + "static/media/Heydn Ericson.92e589ed.png";